import * as React from 'react';
import { StickyCallToAction, Price } from '@grandvisionhq/common';
import { useProductData } from '../../context/product-context-hooks.js';

const StickyMobileCtaAndPrice = ({ cta , className  })=>{
    const { displayPrice  } = useProductData();
    let priceValue = displayPrice.originalPrice;
    let priceType = 'default';
    const discountedValue = displayPrice.discountedPrice;
    if (discountedValue) {
        priceValue = discountedValue;
        priceType = 'discount';
    }
    return /*#__PURE__*/ React.createElement(StickyCallToAction, {
        className: className,
        button: cta,
        price: /*#__PURE__*/ React.createElement(Price, {
            value: priceValue,
            currency: displayPrice.currency,
            centAmount: false,
            type: priceType
        })
    });
};

export { StickyMobileCtaAndPrice };
//# sourceMappingURL=StickyMobileCtaAndPrice.js.map
